import React, { useEffect } from "react";
import { Node } from "reactflow";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { Event } from "../types/types";
import "./EventCard.css";

interface EventCardProps {
  visible: boolean;
  nodeEvent: Event;
  setShowEventCard: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddUpdateEvent: (
    id: string,
    nodeTitle: string,
    title: string,
    description: string,
    date: Date | undefined,
  ) => void;
  handleDeleteEvent: (id: string) => void;
}

const EventCard: React.FC<EventCardProps> = ({
  visible,
  nodeEvent,
  setShowEventCard,
  handleAddUpdateEvent,
  handleDeleteEvent,
}) => {
  const [id, setId] = React.useState<string>("");
  const [title, setTitle] = React.useState<string>("");
  const [description, setDescription] = React.useState<string>("");
  const [date, setDate] = React.useState<Date | undefined>(undefined);

  useEffect(() => {
    setId(nodeEvent?.id || "");
    setTitle(nodeEvent?.title || "");
    setDate(
      nodeEvent?.date
      ? typeof nodeEvent.date === "object" && "seconds" in nodeEvent.date
        ? new Date((nodeEvent.date as { seconds: number }).seconds * 1000)
        : new Date(nodeEvent.date)
      : undefined
    );
    setDescription(nodeEvent?.description || "");
  }, [nodeEvent]);

  return (
    <Dialog
      header={id ? "Edit" : "Add"}
      visible={visible}
      modal
      style={{ width: "400px" }}
      onHide={() => setShowEventCard(false)}
      footer={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {id && (
            <Button
              label="Delete"
              icon="pi pi-trash"
              className="p-button-danger p-button-text"
              style={{ alignSelf: "flex-start" }}
              onClick={() => {
                handleDeleteEvent(id);
                setShowEventCard(false);
              }}
            />
          )}
          <span style={{ marginLeft: "auto" }}>
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => setShowEventCard(false)}
            />
            <Button
              label="Save"
              icon="pi pi-check"
              onClick={() => {handleAddUpdateEvent(id, nodeEvent ? nodeEvent.nodeTitle : title, title, description, date); setShowEventCard(false)}}  
              autoFocus
            />
          </span>
        </div>
      }
    >
      <div className="p-fluid">
        <div className="p-field">
          <label htmlFor="event-title">Title</label>
          <InputText
            id="event-title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            autoFocus
            style={{ fontSize: "1rem", width: "95%" }}
          />
        </div>
        <div className="p-field event-field">
          <label htmlFor="event-date">Date</label>
          <Calendar
            id="event-date"
            value={date}
            onChange={(e) => setDate(e.value as Date | undefined)}
            showIcon
            dateFormat="yy-mm-dd"
            style={{ fontSize: "1rem", height: "2.7rem" }}
            inputStyle={{ fontSize: "1rem" }}
          />
        </div>
        <div className="p-field event-field">
          <label className="label-headers" htmlFor="event-notes">
            Description
          </label>
          <InputTextarea
            id="event-notes"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={2}
            style={{ fontSize: "1rem", width: "95%" }}
            autoResize
          />
        </div>
      </div>
    </Dialog>
  );
};

export default EventCard;
